import { render, staticRenderFns } from "./PushOrders.vue?vue&type=template&id=0cfc8d88&"
import script from "./PushOrders.vue?vue&type=script&lang=js&"
export * from "./PushOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports